import React, { useEffect, useRef, useState } from "react";
import {Dropdown, Modal, Tooltip, Popover} from 'antd';
import styles from "./scss/topheader.module.scss";
import { chatwindowDetails, initialStateModel, LoginState, profileDetails } from "../../../models/model";
import { useSelector } from "react-redux";
import { URAvatarGroup } from "../../../shared/widgets/avatarGroup";
import store from "../../../context/store/store";
import { ChatService as Service } from "../../../base/chatService";
import { chatSDK } from "unifiedring-sdk";
import { Types } from "../../../context/action/action";
import { useHistory } from "react-router-dom";
import {  Cookie, SignOut } from "../../../base/utils";
import { config } from "../../../base/constant";
import { SocketChatService } from "../../../base/socketChatService";
import { userInfo } from "../../../base/socketChatService/utils";
import moment from "antd/node_modules/moment";
import { callmeetingnotification, chatSideWindow, getVideoMeetSetting } from "../../../base/eventService/eventApiService";
import BellNotification from "../../../components/bellNotification/chatBellNotify";

type TopHeaderState = {
  activeStatus: string;
  userStatus: string;
  isSelect: boolean;
  isModalVisible: boolean;
}
function TopHeader(this: any) {
  const history = useHistory();
  const loginDetails: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  const profileUserDetails:  profileDetails = useSelector((state: any) => state.profileReducer);
  const chatWindow: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);
  const {bellNotificationCount}: any = useSelector((state: initialStateModel) => state.bellNotification);
  //const contactList: contacts = useSelector((state: initialStateModel) => state.contactReducer);
  let {isMySpace} = chatWindow;
  const {isemergencyAddressData,userStatusData,isvideoprofile}=profileUserDetails;
 
  const [ProfileData, setProfileData] = useState<TopHeaderState>({activeStatus:loginDetails?.userdetails?.user_status,
    userStatus:userStatusData,isSelect:false,isModalVisible:false});

    const activeDeviceStatus = ["Available","Busy","Do not disturb","Invisible","Appear Busy",
    "Appear Away","Appear Offline","In a Call","Presenting","In a Meeting"];
  let mySpaceDetials:any =loginDetails.userdetails;
  const [visible, setvisible] = useState(false);
  const [getvisible, setVisible] = useState(false);
  const [duration, setDuration] = useState<any>(null);
  const [userStatus, updateUserStatus] = useState<any>('');
  const timeOutRef = useRef<any>(null);
  const socketService = useRef<any>(null);
  const visibility = useRef<string>('');
  const [mount,setMount] = useState<boolean>(false);
  const [isMyspaceactive, setMyspaceactive] = useState(false);
  const showModal = () => { setProfileData({ ...ProfileData, isModalVisible: true }); };
  // console.log("contactList --->",contactList?.workContactsnew);
  const updateUserPresencestatus = () => {

    let Statusdata = {

      status_msg: ProfileData.userStatus,
      status_indicator: 0,
      type: 1

    };
    new chatSDK.ChatRestService().updateStatusNote(Statusdata).then((res: any) => {

      if (res?.statusCode === 200) {

        store.dispatch({
          type: Types.USER_STATUS,
          payload: {
            userStatusData: ProfileData.userStatus,
            isUserStatus: true

          }
        });
        setProfileData({ ...ProfileData, isModalVisible: false ,isSelect:false});
      }
    });

    // new chatSDK.ChatRestService().updateStatusNote(Statusdata).then((res: any) => {
    // });

  };
  const handleCancel4 = () => { setProfileData({ ...ProfileData, isModalVisible: false,isSelect:false }); };

  const handleVisibleChange = (flag: any) => {
    setvisible(flag);
  };

  const setMySpace=()=>{

    setMyspaceactive(true);
    
    if(window.location.pathname!=="/chats"){
      history.push('/chats');
    }
    
    let mySpaceDetials:any =loginDetails.userdetails;
    mySpaceDetials.isMySpace = true;
    mySpaceDetials.jid = `${mySpaceDetials.sip_login_id}@${mySpaceDetials.host_address}`;
    Service.openChatWindow(mySpaceDetials);
    const socketChat = new SocketChatService(userInfo().fromID, userInfo().domainId);
    socketChat.getChatHistory(`chat${userInfo().fromID}${userInfo().fromID}${userInfo().domainId}`,"")
    Service.emptyOnMyspace();
    Service.editDraft("");
    chatSideWindow(false,"",{});
    store.dispatch({
      type: Types.TAB_CHANGE,
      payload: {
        ActiveTab: "1"
      }
    });
   //console.log(isMyspaceactive,"isMyspaceactive");
  
  };

  const getVideoSetting = () =>{
    getVideoMeetSetting();

  }
  const settingsData = ()=>{
    new chatSDK.ChatRestService().getEmergNumber().then((res)=>{
   
      if(res?.statusCode===200){
        if(res?.result?.length > 0 ){
          let  emergencyAddressData={
            buildingName:res?.result[0]?.address_line_1,
            streetName:res?.result[0]?.address_line_2,
            city:res?.result[0]?.city,
            country:res?.result[0]?.country,
            pinCode:res?.result[0]?.post_code};
          store.dispatch({
            type: Types.EMERGENCY_ADDRESS,
            payload:{emergencyAddressData:emergencyAddressData,
              isemergencyAddressData:true}
          });
      
        }
          
      }
       
    });
  };
  const visibilityChange = () =>{
      const userInfo:any =Cookie.get();
      const userInfosess: any = sessionStorage.getItem("userinfo");
      if(userInfosess){
        const cookieData =JSON.parse(userInfosess);
        socketService.current= new SocketChatService(cookieData.sip_login_id, cookieData.domain_id);
      }
      if(document.hidden)
        {
          if(!visibility.current  || visibility.current==="view"){
            visibility.current =  "hidden";
            // console.log("User Status Indicator --->",userStatus?.status_indicator);
            if(userStatus?.manualFlag===0 && userStatus?.status_indicator!==9
              && userStatus?.status_indicator!==8  && userStatus?.status_indicator!==7){

              let updateData= {
                status_msg:"Appear Away",
                status_indicator:5,
                userStatusStimestamp: userStatus?.userstatus_timestamp,
                manualFlag: 0,
                timeDuration:"4",
                prevStatus:0,
                type:2
                };
                updateNoteData(updateData)
                // updateUserStatus(updateData);
            }
           
          }
        }
      else
        {
          if(!visibility.current  || visibility.current==="hidden"){
            visibility.current =  "view";
            if(userStatus?.manualFlag===0 && userStatus?.status_indicator!==9
            && userStatus?.status_indicator!==8  && userStatus?.status_indicator!==7){
       
              let updateData= {
                status_msg:"Available",
                status_indicator:0,
                userStatusStimestamp: 0,
                manualFlag: 0,
                timeDuration:"4",
                prevStatus:0,
                type:2
                };
                updateNoteData(updateData)
                // updateUserStatus(updateData);
            }
          }
        }
  }

  const onUnload = () =>{
    new chatSDK.ChatRestService().userGetStatus()
    .then((data:any) => {
    if(data?.statusCode===200){

    let updateData= {
      status_msg:"Appear Offline",
      status_indicator:0,
      userStatusStimestamp: 0,
      manualFlag: 0,
      timeDuration:"4",
      prevStatus:0,
      type:2
      };
      updateNoteData(updateData)
    }
    });

  }
  useEffect(() => {
    if(!mount){
      getUserPrescence();
      if(!isemergencyAddressData){
        settingsData();
      }
      if(!isvideoprofile){
        getVideoSetting();
      }
      
     
      setMount(true);
    }
    window.addEventListener("beforeunload", onUnload);
    document.addEventListener('visibilitychange', visibilityChange);
     return ()=>{
       document.removeEventListener('visibilitychange', visibilityChange);
       window.removeEventListener("beforeunload", onUnload);
      }

  
  }, [userStatus]);

  const socketChat = useRef<any>(null);
  // useEffect(() => {
  //   const userInfo: any = Cookie.get();
  //   if (userInfo["userinfo"]) {
  //     const cookieData = JSON.parse(userInfo["userinfo"]);
  //     socketChat.current = new SocketChatService(cookieData.sip_login_id, cookieData.domain_id);
  //     socketChat.current.getAllBellNotification();
  //   }
  //   callmeetingnotification(3); /// Calls Notifications
  //   callmeetingnotification(4); /// Meetings Notifications
  //   new eventService().getBellNotificationCount()
  //   .then((response: any) => {
  //       //console.log('result Count--------------->',response.count); 
  //       store.dispatch({
  //         type: Types.BELL_NOTIFICATIONS_COUNT,
  //         payloads:{
  //           bellNotificationCount: response.count
  //         }
  //       })
  //   })
  //   .catch((err: any) => {
  //     console.log("err---", err);
  //   });
  // }, []);


const setMyspaceActive=()=>{
  // new eventService().getCallMeetingBellNotificationList('4')
  //     .then((response: any) => {
  //         //console.log('result --------------->',response.result); 
  //     })
  //     .catch((err: any) => {
  //       console.log("err---", err);
  //     });

  setMyspaceactive(false);
}

const updateNoteData =  (updateData:any) =>{
  new chatSDK.ChatRestService().updateStatusNote(updateData).then((res: any) => {
    if(res?.statusCode===200){
      let activeStatus :any= res?.user_status?.status_msg;
      let type = res?.user_status?.type;
      if(type===2){
        setProfileData({ ...ProfileData,activeStatus:activeStatus });
      }
      updateUserStatus(updateData);
    }
  });
}
  const getUserPrescence = () => {
    new chatSDK.ChatRestService().userGetStatus()
      .then((data:any) => {
        if(data?.statusCode === 200){
          let USerstatus :any= data?.user_status?.status_msg;
          let activeStatus:any = data?.user_status?.status_indicator;
          let updateData= {
            status_msg:data?.user_status?.status_msg,
            status_indicator:data?.user_status?.status_indicator_id,
            userStatusStimestamp: data?.user_status?.userstatus_timestamp,
            manualFlag: data?.user_status?.manual_flag,
            timeDuration:data?.user_status?.time_duration,
            prevStatus:data?.user_status?.prev_status ? data?.user_status?.prev_status: 0,
            type:2
            };

            if(data?.user_status?.userstatus_timestamp){
              if(data?.user_status?.manual_flag===0){
                let updateData:any ={};
                updateData.status_msg ="Available";
                updateData.manualFlag = 0;
                updateData.timeDuration = "4";
                updateData.userStatusStimestamp = 0;
                updateData.prevStatus = 0;
                updateData.status_indicator = 0;
                updateData.type =2;
                // console.log('updateData --->',updateData);
                updateNoteData(updateData)
              } else if(data?.user_status?.manual_flag===1){
                // console.log('updateData22 --->',updateData);
                updateNoteData(updateData)
              }
              timeOutRef.current=setTimeout(()=>{
                if(data?.user_status?.manual_flag===1)
                  {
                    updateData.status_msg =activeDeviceStatus[data?.user_status?.prev_status];
                    updateData.manualFlag = 0;
                    updateData.timeDuration = "4";
                    updateData.userStatusStimestamp = 0;
                    updateData.prevStatus = 0;
                    updateData.status_indicator = 0;
                    updateData.type =2;
                    updateNoteData(updateData);
                    setDuration(null);
                  }
                
              },moment(data?.user_status?.userstatus_timestamp).diff(moment())/1000)
            } else {
              let updateData:any ={};
              updateData.status_msg ="Available";
              updateData.manualFlag = 0;
              updateData.timeDuration = "4";
              updateData.userStatusStimestamp = 0;
              updateData.prevStatus = 0;
              updateData.status_indicator = 0;
              updateData.type =2;
              // console.log("User Time Stamp 1 --->",updateData);
              updateNoteData(updateData);
            }
            //moment(data?.user_status?.userstatus_timestamp).diff(moment())/1000
            // timeDuration: data?.user_status?.,
          if(parseInt(data?.user_status?.status_indicator)!==0){
            setDuration(data?.user_status?.time_duration);
            console.log(duration,"duration");
          }
          
          if(mySpaceDetials.user_status){
            mySpaceDetials.user_status = data?.user_status?.status_indicator;
              store.dispatch({
                type: Types.ADD_LOGIN,
                payload: { userdetails: mySpaceDetials }
              });
          }
          // console.log(activeStatus,'updateData --->',USerstatus);
   
          setProfileData({ ...ProfileData, userStatus: USerstatus,activeStatus:activeStatus });
        } else if (!data) {
          // history.push('/login');
          // Cookie.clear();
        }

      }).catch((err: any) => {
      });

  };

  const onchangeStatus=(key:any)=>{
    setProfileData({...ProfileData,userStatus:key,isSelect:true});
  };

  const openprofile=(setVal:boolean,tab:any)=>{
    history.push('/profile');
    store.dispatch({
      type: Types.OPEN_SETTINGS,
      payload: {
        isSettings:setVal,
        isSettingTab: tab
      }
    });
  };

  // const hoursUpdate = ({key}:any) =>{
  //   let timeStamp = 0;
  //   if(key==="1"){
  //     timeStamp = moment().add(30, 'minutes').valueOf();
  //   }
  //   if(key==="2"){
  //     timeStamp = moment().add(1, 'hours').valueOf();
  //   }
  //   if(key==="3"){
  //     timeStamp = moment().add(2, 'hours').valueOf();
  //   }
  //   if(key==="4"){
  //     // start time and end time
  //     timeStamp = moment(moment().endOf('day'), 'HH:mm:ss a').valueOf();
  //   }
  //   if(key==="5"){
  //     timeStamp = moment().endOf('week').valueOf();
  //   }

  //   if(userStatus && userStatus?.timeDuration){
  //     userStatus.timeDuration = key;
  //     userStatus.userStatusStimestamp = timeStamp;
  //   }
  //   setDuration(key);
  //   console.log("userStatus --->",userStatus);
  //   new chatSDK.ChatRestService().updateStatusNote(userStatus).then((res: any) => {
  //     if(res?.statusCode===200){
  //       let type = res?.user_status?.type;
  //       if(type===2){
  //         setProfileData({ ...ProfileData,activeStatus:activeDeviceStatus[res.user_status.status_indicator] });
  //       }
  //       if(res?.user_status?.userstatus_timestamp){
  //         if(timeOutRef.current){
  //           clearTimeout(timeOutRef.current)
  //         }
          
  //         timeOutRef.current=setTimeout(()=>{
  //           if(res?.user_status?.manualFlag===1 && res?.user_status?.userstatus_timestamp)
  //           {
  //             let updateData:any ={};
  //             updateData.status_msg =activeDeviceStatus[res?.user_status?.prev_status];
  //             updateData.manualFlag = 0;
  //             updateData.timeDuration = "4";
  //             updateData.userStatusStimestamp = 0;
  //             updateData.prevStatus = 0;
  //             updateData.status_indicator = 0;
  //             updateData.type =2;
  //             updateNoteData(updateData)
  //             setDuration(null);
  //           }
  //         },res?.user_status?.userstatus_timestamp - moment().valueOf()/1000)
  //       }
  //       updateUserStatus(userStatus);
  //     }
  //   });
  // }

  // const menu2 = (
  //   <Menu onClick={statusUpdate} className="profileMeundrpdwn">
  //     <Menu.Item key={"Available"} className={styles.selected}>
  //       <span className={`bgGreen ${styles.stsDot}`}></span>Active</Menu.Item> 
  //     {/* <Menu.Item key={"In a Call"}><span className={`bgRed ${styles.stsDot}`}></span>In a call</Menu.Item> */}
  //     {/* <Menu.Item key={"Do not disturb"}>
  //       <span className={`${styles.stsDND}`}></span>Do not Disturb</Menu.Item>
  //     <Menu.Item key={"Appear Busy"}><span className={`bgRed ${styles.stsDot}`}></span>Busy</Menu.Item>
  //     <Menu.Item key={"Appear Away"}><span className={`bgYello ${styles.stsDot}`}></span>Away</Menu.Item> */}
  //   </Menu>
  // );
  // const resetDuration = () =>{
  
  //   if(userStatus && userStatus?.timeDuration){
  //     userStatus.userStatusStimestamp = moment().add(24, 'hours').valueOf();;
  
  //     new chatSDK.ChatRestService().updateStatusNote(userStatus).then((res: any) => {
  //       if(res?.statusCode===200){
  //         updateUserStatus(userStatus);
  //         if(res?.user_status?.userstatus_timestamp){
  //           if(timeOutRef.current){
  //             clearTimeout(timeOutRef.current)
  //           }
  //           // timeOutRef.current=setTimeout(()=>{
  //           //   console.log("TimeOut Ref1 --->");
  //           // },moment(res?.user_status?.userstatus_timestamp).diff(moment())/1000);
  //           //moment(res?.user_status?.userstatus_timestamp).diff(moment())/1000
  //         }
  //         setProfileData({ ...ProfileData,activeStatus:activeDeviceStatus[res.user_status.status_indicator] });
  //       }
  //     });
  //   }
  //   setDuration(null);
  // }
  // console.log("loginDetails?.userdetails",loginDetails?.userdetails);
 // const durationInter = ["30 Minutes","1 hour", "2 hours", "Today","This week"];
 
  const menu = (
    <div className={styles.userOption}>
      <div className={styles.profilelists}>
        <div className={`${styles.lefts} ${styles.three}`}>
        {loginDetails?.userdetails?.profile_url ?
                    <img src={loginDetails?.userdetails?.profile_url} alt="" />:<span>
          {loginDetails?.userdetails?.caller_id?.charAt(0).toUpperCase()}</span>}
          </div>
      </div>
      <div className={styles.middle}>
        <h4>{mySpaceDetials?.caller_id}</h4>
      </div>
      {/* <Dropdown overlay={menu2} trigger={['click']} placement="bottomCenter"> */}
        <p className={styles.activedrpDwn} onClick={e => e.preventDefault()}>
        <span className={`bgGreen ${styles.stsDot}`}></span>Available
          {/* {loginDetails?.userdetails?.user_status === "Available"
            ? <span className={`bgGreen ${styles.stsDot}`}></span> :
            loginDetails?.userdetails?.user_status === "Appear Away" ?
              <span className={`bgYello ${styles.stsDot}`}></span> :
              (loginDetails?.userdetails?.user_status === "Appear Busy" || loginDetails?.userdetails?.user_status === "In a Call" ||
              loginDetails?.userdetails?.user_status=== "In a Meeting" || loginDetails?.userdetails?.user_status=== "In a Meeting") ?
              <span className={`bgRed ${styles.stsDot}`}></span> :
              loginDetails?.userdetails?.user_status === "Do not disturb"?
                <span className={`${styles.stsDNDTop}`}></span> :
                // (ProfileData.activeStatus==="Away"|| loginDetails?.userdetails.user_status==="Invisible")&&
                <span className={`bgGrey ${styles.stsDot}`}></span>
          }{loginDetails?.userdetails?.user_status === "Available" ? "Available" :
            (loginDetails?.userdetails?.user_status === "Appear Busy") ? "Busy" :
            (loginDetails?.userdetails?.user_status === "Appear Away" && userStatus?.manualFlag===0) ? "Away" :
            loginDetails?.userdetails?.user_status === "Do not disturb" ? "Do not disturb" :
              (loginDetails?.userdetails?.user_status === "Appear Offline"  && userStatus?.manualFlag===0)?"Offline":""
          } */}

          {/* <span className={styles.menudropRotate}>
          </span> */}
        </p>
      {/* </Dropdown> */}
      {/* {!duration && (ProfileData?.activeStatus!=="Available" && ProfileData?.activeStatus!=="In a Call") && 
      <Dropdown trigger={['click']} overlay={menu3} placement="bottomCenter">
        <p className={styles.setDuration}><span className={styles.clickable}>Set Duration</span></p>
      </Dropdown>} */}
      {/* {duration && (ProfileData?.activeStatus!=="Available" && ProfileData?.activeStatus!=="In a Call") && <p className={styles.setDuration}><span className={styles.udtdDur}>up to {durationInter[duration-1]} </span>
          <span className={styles.clickable} onClick={resetDuration}>Reset</span></p>} */}
      <ul className={styles.userOptionList}>
        <li  onClick={()=>openprofile(false,'profile')} >View Profile</li>
        <li  onClick={()=>openprofile(true,'setting')}>Settings</li>
        <li>
          <a href={config().HELPCENTER} target="__blank">Help</a>
        </li>
        <li>
          <a href={config().ABOUT} target="__blank">About</a>
        </li>
        <li onClick={() => SignOut(history)} className={styles.signoutBtn}>Signout of Worktual</li>
      </ul>
      {(!ProfileData.isSelect && ProfileData.isModalVisible ) ||  userStatusData === ''   ? <div className={styles.inputBox} onClick={showModal}>
        <span className="icon_happy"></span> Update your status
      </div> : <div className={styles.inputBox} onClick={showModal}>
        <span className={userStatusData === "In a Meeting" ? "icon_Calendar" :
          userStatusData === "Travelling" ? "icon_Van" :
          userStatusData === "Sick" ? "icon_sad" :
                userStatusData === "On Vacation" ? "icon_Natural" :
                userStatusData === "Working Remotely" ? "" : ""
        } >
        </span>{userStatusData}</div>}
    </div>
  );

  const hide = () => {
    setVisible(false);
  };
    const sethandleVisibleChange = (newVisible: boolean) => {
    callmeetingnotification(); /// Calls Notifications
    setVisible(newVisible);
    if(newVisible === true){
    const userInfo: any = Cookie.get();
    const userInfosess: any = sessionStorage.getItem("userinfo");
    if (userInfosess) {
      const cookieData = JSON.parse(userInfosess);
      socketChat.current = new SocketChatService(cookieData.sip_login_id, cookieData.domain_id);
      socketChat.current.getAllBellNotification();
    }
   
    // new eventService().getBellNotificationCount()
    // .then((response: any) => {
    //     //console.log('result Count--------------->',response); 
    //     store.dispatch({
    //       type: Types.BELL_NOTIFICATIONS_COUNT,
    //       payloads:{
    //         bellNotificationCount: response.count
    //       }
    //     })
    // })
    // .catch((err: any) => {
    //   console.log("err---", err);
    // });
    }
  };
  const notification = (
    <BellNotification />
    );

const total_bell_count=bellNotificationCount.bellNotificationCount;
//console.log('total_bell_count ------', bellNotificationCount.bellNotificationCount);
  return (
    <>
      <div className={styles.topheader}>
        <ul>
          <li onClick={setMySpace} className={isMySpace ? styles.myspaceactive : ""}>
            <Tooltip mouseEnterDelay={0.5} placement="left" title="My space" className={styles.myspaceBtn}>
              <span className={styles.myspaceIcon}></span>
              <span className={styles.myspaceIconTop}></span>
            </Tooltip></li>
            {/* <Popover
              content={<a onClick={hide}>{notification}</a>}
              trigger="click"
              overlayClassName="notification"
              placement="bottomLeft"
              visible={getvisible}
              onVisibleChange={sethandleVisibleChange}
            >
      <li className={styles.notifyBell} onClick={setMyspaceActive}>
            <span className="icon_notificationnew" ></span>{total_bell_count > 0?<b className={styles.alertsico}></b>:''}</li>
            </Popover> */}

{/* 
    <Popover content={notification}
      trigger="click"
      overlayClassName="notification"
      visible={visible1}
      placement="bottomLeft"
      onVisibleChange={handleVisibleChange1}>
      <li className={styles.notifyBell} >
      <span className="icon_notificationnew" ></span><b className={styles.alertsico}></b></li>
    </Popover> */}

            

          <Dropdown visible={visible} overlay={menu} placement="bottomRight" trigger={['click']} onVisibleChange={handleVisibleChange}>
            <li>
              <>
               
                <URAvatarGroup className='lefts size32 profileRound colorBG1'
                  profileInfo={<>{loginDetails?.userdetails?.profile_url ?
                    <img src={loginDetails?.userdetails?.profile_url} alt="" />
                    : <span>{loginDetails?.userdetails?.caller_id?.charAt(0)?.toUpperCase()}</span>}</>}
                />
                {/* <div className="headerProfilests bgGreen" ></div> */}
                {loginDetails?.userdetails?.user_status === "Available" ?
                  <div className="headerProfilests bgGreen" ></div>

                      : <div className="headerProfilests bgGrey" ></div>
                }


              
                <span className={`leftmenudrops menudroprotate ${"icon_down-arrow"} ${styles.menudrop}`}></span>
              </>
            </li>
          </Dropdown>
        </ul>
      </div>

      <Modal visible={ProfileData.isModalVisible} title="Set a status"
        centered
        onOk={updateUserPresencestatus}
        onCancel={handleCancel4}
        cancelText="Cancel"
        okText="Save"
        cancelButtonProps={{ className: 'urButton buttonWhite' }}
        okButtonProps={{ className: 'urButton buttonBlue' }} className="customPopup  statusPopup">
        {!ProfileData.isSelect ? <div className={styles.inputBoxpp} >
          <span className="icon_happy"></span>  Update your status
        </div> : <div className={styles.inputBoxpp} >
          <span className={ProfileData.userStatus === "In a Meeting" ? "icon_Calendar" :
            ProfileData.userStatus === "Travelling" ? "icon_Van" :
              ProfileData.userStatus === "Sick" ? "icon_sad" :
                ProfileData.userStatus === "On Vacation" ? "icon_Natural" : "icon_Home"
          } >
          </span>{ProfileData.userStatus}<span className="icon_closefill"
            onClick={() => setProfileData({ ...ProfileData, userStatus: '', isSelect: false })}></span>
        </div>}
        {!ProfileData.isSelect ? <ul className={styles.userOptionList}>
          <li onClick={() => onchangeStatus("In a Meeting")}><span className="icon_Calendar"></span> In a Meeting</li>
          <li onClick={() => onchangeStatus("Travelling")}><span className="icon_Van"></span> Travelling</li>
          <li onClick={() => onchangeStatus("Sick")}><span className="icon_sad"></span> Sick</li>
          <li onClick={() => onchangeStatus("On Vacation")}><span className="icon_Natural"></span> On Vacation</li>
          <li onClick={() => onchangeStatus("Working Remotely")}>
            <span className="icon_Home"></span> Working Remotely</li>
        </ul> : null}
      </Modal>
    </>
  );
};

export default React.memo(TopHeader);